import {
	API_GET_DEPOSIT_PLACES,
	API_GET_DEPOSIT_PLACES_SUCCESS,
	API_GET_DEPOSIT_SAMPLERS,
	API_GET_DEPOSIT_SAMPLERS_SUCCESS,
} from "../actions/deposit";
import { createReducer } from "@reduxjs/toolkit";
import { getVersion } from "services/deposit";
import { DEFAULT_CLIENT, V2_CLIENT } from "config/clientConstants";

const adaptDepositResponse = (deposit, currentClient) => {
	try {
		if (!deposit || currentClient !== V2_CLIENT) {
			return deposit;
		}

		const adapted = { ...deposit };

		const fieldMap = {
			prelDate: 'prel_date',
			createdDate: 'created_date',
		};

		Object.keys(fieldMap).forEach((camelKey) => {
			if (adapted[camelKey] !== undefined && adapted[fieldMap[camelKey]] === undefined) {
				adapted[fieldMap[camelKey]] = adapted[camelKey];
			}
		});

		if (adapted.folder && typeof adapted.folder === 'object' && adapted.folder.id !== undefined) {
			if (adapted.folder_id === undefined) {
				adapted.folder_id = adapted.folder.id;
			}
		}

		if (adapted.sampler && typeof adapted.sampler === 'object' && adapted.sampler.id !== undefined) {
			if (adapted.sampler_id === undefined) {
				adapted.sampler_id = adapted.sampler.id;
			}
		}

		if (adapted.prelPlace && typeof adapted.prelPlace === 'object' && adapted.prelPlace.id !== undefined) {
			if (adapted.prel_place_id === undefined) {
				adapted.prel_place_id = adapted.prelPlace.id;
			}
		}

		return adapted;
	} catch (error) {
		console.error('Error in adaptDepositResponse:', error);
		return deposit;
	}
};

const adaptDepositPayloadResponse = (action, actionType) => {
	try {
		const payload = action.payload || {};
		const data = payload.data;
		const currentClient = action.meta?.previousAction?.payload?.client || getVersion(actionType).currentClient;

		if (!data) {
			return payload;
		}

		if (currentClient === V2_CLIENT) {
			if (Array.isArray(data)) {
				const adaptedData = data.map((item) => adaptDepositResponse(item, currentClient));
				return {
					...payload,
					data: adaptedData,
				};
			} else if (typeof data === 'object' && data !== null) {
				if (data.deposit) {
					const adaptedDeposit = adaptDepositResponse(data.deposit, currentClient);
					return {
						...payload,
						data: {
							...data,
							deposit: adaptedDeposit,
						},
					};
				} else {
					const adaptedData = adaptDepositResponse(data, currentClient);
					return {
						...payload,
						data: adaptedData,
					};
				}
			}
		}

		return payload;
	} catch (error) {
		console.error('Error in adaptDepositPayloadResponse:', error);
		return action.payload || {};
	}
};

const initialState = {
	places: [],
	samplers: [],
	loading: false,
};

const deposit = createReducer(initialState, {
	[API_GET_DEPOSIT_PLACES_SUCCESS]: (state, action) => {
		state.loading = false;
		const adaptedPayload = adaptDepositPayloadResponse(action, API_GET_DEPOSIT_PLACES);
		state.places = adaptedPayload.data || [];
	},

	[API_GET_DEPOSIT_SAMPLERS_SUCCESS]: (state, action) => {
		state.loading = false;
		const adaptedPayload = adaptDepositPayloadResponse(action, API_GET_DEPOSIT_SAMPLERS);
		state.samplers = adaptedPayload.data || [];
	},
});

export default deposit;
